/**
 * Strips the substring "data:image/jpeg;base64,"
 * from string and returns result.
 * This is needed to send image data to Mitek properly
 */
export function stripImageData(imageData) {
  const regex = /(data:image\/jpeg;base64,)/g;
  return imageData.replace(regex, "");
}
